import api, { unwrap } from './client';

// Hypothèses du Prévisionnel (BFRE + cash flow), par tenant × année.
// GET → { dso, dpo, dio, pac, cf_invest, cf_cession, cf_fin } (clés présentes seulement).
export const getForecastAssumptions = (tenantId, year) =>
  unwrap(api.get(`/financials/forecast-assumptions/${tenantId}/${year}`));

// Upsert d'une clé (valeur vide/null → suppression côté serveur).
export const putForecastAssumption = (tenantId, year, akey, value) =>
  unwrap(api.put(`/financials/forecast-assumptions/${tenantId}/${year}`, { akey, value }));
